import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3StorageCopyError = BaseErrorSchema.extend({
  errorType: z.literal('S3StorageCopyError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  sourceKey: z.string(),
  destinationKey: z.string(),
  errorReason: z.string(),
});

export type S3StorageCopyError = z.infer<typeof S3StorageCopyError>;
